import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import { Box } from '@material-ui/core'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { DB } from '../../firebase'
import {
    HeadingContainer,
    BadgeHeading,
    SectionHeading,
    HeadingDescription,
    GradientText
} from './HeadingComponenents'

import {
    HeadingGradientShift,
    HeadingScaleGlow,
    HeadingUnderline,
    HeadingGradientUnderline,
    HeadingPulse
} from './Headinghovercomponents'

function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return (
        <div
            className={`${className} arrow_slick`}
            style={style}
            onClick={onClick}
        >
            <ChevronRightIcon style={{ color: '#222', fontSize: '20px' }} />
        </div>
    )
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    
    return (
        <div
            className={`${className} arrow_slick`}
            style={style}
            onClick={onClick}
        >
            <ChevronLeftIcon style={{ color: '#222', fontSize: '20px' }} />
        </div>
    )
}

export default function StudentTestimonials({ type, limit = null }) {
    const [testimonials, setTestimonials] = useState([])
    const [loading, setLoading] = useState(true)

    // Fetch testimonials from Firestore
    useEffect(() => {
        const fetchTestimonials = async () => {
            try {
                let query = DB.collection('testimonials')
                    .where('active', '==', true)
                    .orderBy('timestamp', 'desc')

                if (limit) {
                    query = query.limit(limit)
                }

                query.onSnapshot((querySnapshot) => {
                    const testimonialsData = []
                    querySnapshot.forEach((doc) => {
                        testimonialsData.push({
                            id: doc.id,
                            ...doc.data()
                        })
                    })
                    setTestimonials(testimonialsData)
                    setLoading(false)
                })
            } catch (error) {
                console.error('Error fetching testimonials:', error)
                setLoading(false)
            }
        }

        fetchTestimonials()
    }, [limit])

    // Filter testimonials by type if provided
    const filteredTestimonials = type 
        ? testimonials.filter(t => 
            t.testimonial?.toLowerCase().includes(type.toLowerCase()) ||
            t.subject?.toLowerCase().includes(type.toLowerCase())
          )
        : testimonials

    // Slider settings
    const settings = {
        dots: true,
        infinite: filteredTestimonials.length > 3,
        autoplaySpeed: 3000,
        autoplay: true,
        slidesToShow: Math.min(3, filteredTestimonials.length),
        swipeToSlide: true,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        cssEase: 'ease-in-out',
        responsive: [
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: Math.min(2, filteredTestimonials.length),
                    infinite: filteredTestimonials.length > 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    infinite: filteredTestimonials.length > 1
                }
            }
        ]
    }

    // Render star rating
    const renderStars = (rating) => {
        const stars = []
        const fullStars = Math.floor(rating)
        const hasHalfStar = rating % 1 !== 0

        for (let i = 0; i < fullStars; i++) {
            stars.push(<span key={`full-${i}`} className="star-icon">★</span>)
        }

        if (hasHalfStar) {
            stars.push(<span key="half" className="star-icon half">★</span>)
        }

        // Empty stars
        const totalStars = hasHalfStar ? fullStars + 1 : fullStars
        for (let i = totalStars; i < 5; i++) {
            stars.push(<span key={`empty-${i}`} className="star-icon empty">☆</span>)
        }

        return stars
    }

    // Format role with class and subject
    const formatRole = (testimonial) => {
        let role = testimonial.designation || ''
        
        if (testimonial.studentClass) {
            role += ` - Class ${testimonial.studentClass}`
        }
        
        if (testimonial.subject) {
            role += ` (${testimonial.subject})`
        }
        
        return role
    }

    if (loading) {
        return (
            <section className="testimonials-section">
                <div className="testimonials-container">
                <HeadingContainer>
                    <HeadingGradientShift><HeadingPulse>
                        <SectionHeading>
                            What Parents Say<GradientText> About Us</GradientText>
                        </SectionHeading>
                        </HeadingPulse>
                        <HeadingDescription>
                            Loading testimonials ....
                        </HeadingDescription>
                    </HeadingGradientShift>
                </HeadingContainer>
                </div>
            </section>
        )
    }

    if (!filteredTestimonials.length) {
        return (
            <section className="testimonials-section">
                <div className="testimonials-container">
                <HeadingContainer>
                    <HeadingGradientShift><HeadingPulse>
                        <SectionHeading>
                            What Parents Say<GradientText> About Us</GradientText>
                        </SectionHeading>
                        </HeadingPulse>
                        <HeadingDescription>
                           No testimonials available at the moment.
                        </HeadingDescription>
                    </HeadingGradientShift>
                </HeadingContainer>
                </div>
            </section>
        )
    }

    return (
        <section className="testimonials-section">
            <div className="testimonials-container">
                <HeadingContainer>
                    <HeadingGradientShift><HeadingPulse>
                        <SectionHeading>
                            What Parents Say<GradientText> About Us</GradientText>
                        </SectionHeading>
                        </HeadingPulse>
                        
                    </HeadingGradientShift>
                    <HeadingDescription>
                            Hear from happy parents and students about their learning journey.
                        </HeadingDescription>
                </HeadingContainer>

                <Box className="testimonials-slider-wrapper">
                    <Slider {...settings}>
                        {filteredTestimonials.map((testimonial) => (
                            <div key={testimonial.id} className="testimonial-slide">
                                <div className="testimonial-card">
                                    <div className="testimonial-image-wrapper">
                                        <img 
                                            src={testimonial.image || 'https://via.placeholder.com/300x200?text=No+Image'} 
                                            alt={`${testimonial.name} testimonial`} 
                                            className="testimonial-image" 
                                            onError={(e) => {
                                                e.target.src = 'https://via.placeholder.com/300x200?text=No+Image'
                                            }}
                                        />
                                        
                                    </div>
                                    <div className="testimonial-content">
                                        <p className="testimonial-text">
                                            {testimonial.testimonial}
                                        </p>
                                        <div className="testimonial-rating">
                                            {renderStars(testimonial.rating)}
                                        </div>
                                    </div>
                                    <div className="testimonial-author">
                                        <div className="author-name">{testimonial.name}</div>
                                        <div className="author-designation">
                                            {formatRole(testimonial)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </Box>
            </div>
        </section>
    )
}